import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { AlertController, LoadingController } from '@ionic/angular';
import { IBackbarRow, ReportService } from '../../services/report.service';
import { UserService } from '../../services/user.service';
import { Stylist } from '../../models/stylist/stylist.model';
import { Utilities } from '../../utilities/utilities';
import { SMPickerRange } from '../../components/smr-date-picker/smr-date-picker.component';
import { List } from 'immutable';
import { StylistPickerComponent } from '../../components/stylist-picker/stylist-picker.component';
import { ExportTableService } from '../../services/export-table.service';
import { CalendarService } from '../../services/calendar.service';
import { ChartsService } from '../../services/charts.service';
import { Router } from '@angular/router';

// import { GoogleAnalytics } from '@awesome-cordova-plugins/google-analytics';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';
import 'chart.piecelabel.js';

import { ChartConfiguration } from 'chart.js';
import { CloudData, CloudOptions } from 'angular-tag-cloud-module';
interface IRow {
  name: string;
  size: string;
  brand: string;
  category: string;
  supplier: string;
  count: number;
}
interface primeNgCol {
  field: string;
  header: string
}

interface ISelectOption {
  label: string;
  value: string;
}
export interface IInventoryRow {
  productID: number,
  productName: string,
  productSize: string,
  brand: string,
  category: string,
  supplier: string,
  quantity: number,
  reorderPoint: number,
  cost: number,
  retailPrice: number,
}
@Component({
  selector: 'app-inventory-report',
  templateUrl: './inventory-report.page.html',
  styleUrls: ['./inventory-report.page.scss'],
})
export class InventoryReportPage implements OnInit {


  @ViewChild(StylistPickerComponent) stylistPickerComponent: StylistPickerComponent;

  public stats: Array<IInventoryRow>;

  public cols: primeNgCol[];

  public salonID: number;

  public readOnlyStylistPicker: boolean;

  public isLoading: boolean;

  public errorOccurredWhileLoadingStats: boolean;

  public currentDate: Date;

  public brands: Array<ISelectOption> = [{ label: "All brands", value: null }];

  public categories: Array<ISelectOption> = [{ label: "All categories", value: null }];

  public suppliers: Array<ISelectOption> = [{ label: "All suppliers", value: null }];

  public totalQuantity: number;
  public totalCost: number;
  public totalRetailPrice: number;

  constructor(//public navCtrl: NavController,
    //public navParams: NavParams,
    private router: Router,
    public reportService: ReportService,
    public userService: UserService,
    public alertController: AlertController,
    public loadingCtrl: LoadingController,
    private ExportTableService: ExportTableService,
    private CalendarService: CalendarService,
    private ChartsService: ChartsService
    // ,
    // private googleAnalytics: GoogleAnalytics
  ) {

    this.stats = [];
    this.cols = [
      { field: 'name', header: "Name" },
      { field: 'size', header: "Size" },
      { field: 'brand', header: "Brand" },
      { field: 'category', header: "Category" },
      { field: 'supplier', header: "Supplier" },
      { field: 'quantity', header: "Count" },
      { field: 'cost', header: "Cost" },

      { field: 'retailPrice', header: "Retail" }

    ];

  }


  public ngOnInit() {
    this.currentDate = new Date();
    this.salonID = this.userService.getSalon().getId();
  }

  public ngAfterViewInit() {
    this.loadStats(this.currentDate);
  }


  public onTapToReload() {
    this.isLoading = true;
    this.errorOccurredWhileLoadingStats = false;
    this.stylistPickerComponent.ngOnInit();
  }

  public loadStats(currentDate) {
    this.isLoading = true;
    this.errorOccurredWhileLoadingStats = false;
    this.reportService.loadInventoryStats(this.salonID, currentDate)
      .subscribe((stats) => {

        this.stats = stats;
        this.summaryTotal();
        this.stats.forEach((item) => {
          if (!this.brands.some((brand) => { return item.brand === brand.label }) && item.brand != '') {
            this.brands.push({ label: item.brand, value: item.brand });
          }
          if (!this.categories.some((category) => { return item.category === category.label }) && item.category != '') {
            this.categories.push({ label: item.category, value: item.category });
          }
          if (!this.suppliers.some((supplier) => { return item.supplier === supplier.label }) && item.supplier != '') {
            this.suppliers.push({ label: item.supplier, value: item.supplier });
          }
        });
        this.isLoading = false;
      },
        (err) => {
          this.isLoading = false;
          this.errorOccurredWhileLoadingStats = true;
        });
  }



  public summaryTotal() {
    this.totalQuantity = this.stats.reduce((total, row) => total + (row.quantity || 0), 0);
    this.totalCost = this.stats.reduce((total, row) => total + (Math.round(Number(row.cost * 100)) / 100 || 0), 0);
    console.log("this.totalCost", this.totalCost);
    this.totalRetailPrice = this.stats.reduce((total, row) => total + (Math.round(Number(row.retailPrice * 100)) / 100 || 0), 0);
    console.log("this.totalRetailPrice", this.totalRetailPrice);
    return { name: "Total", quantity: this.totalQuantity, cost: `${this.totalCost}`, retailPrice: `${this.totalRetailPrice}` };
  }

  public exportPdf() {
    const exportArray = [...this.stats, this.summaryTotal()];

    const formattedExportArray = exportArray.map(item => {
      const formattedItem = { ...item };
      this.cols.forEach(col => {

        if (col.field === 'cost' || col.field === 'retailPrice') {
          formattedItem[col.field] = '$' + formattedItem[col.field];
        }
      });
      return formattedItem;
    });

    this.ExportTableService.exportPdf(formattedExportArray, "Payments", this.cols);
  }
  public exportExcel() {
    const exportArray = [...this.stats, { name: "Total", total: this.summaryTotal(), percentage: "" }];

    const formattedExportArray = exportArray.map(item => {
      const formattedItem = { ...item };
      this.cols.forEach(col => {
        if (col.field === 'cost' || col.field === 'retailPrice') {
          formattedItem[col.field] = '$' + formattedItem[col.field];
        }
      });
      return formattedItem;
    });

    const headers = this.cols.map(col => col.header);

    this.ExportTableService.exportExcel(formattedExportArray, "Payments", headers);
  }

  public onBack() {
    this.router.navigateByUrl('/reports');
  }

}
